import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigUtils } from '../utils/configUtils';
import { UserServices } from './userServices';

enum eDocType{
    factura="Factura",
    notaCredito="Nota Credito",
}
@Injectable()
export class VendedorServices {
  constructor(
    public http: HttpClient,
    public userService: UserServices
  ){}
  getPagosEfectivo():Observable<any>{
    var codVendedor=this.userService.currentUser.IdVendor
    const url=ConfigUtils.getUrlFromEndPointName('vendedor')+'/getPagosEfectivoByCodVendedor/'+codVendedor;
    console.log(url);
    return this.http.get<any>(url);
  }
}
